import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Layout } from "./components/layout/Layout";
import { ScrollToTop } from "./components/layout/ScrollToTop";
import { Toaster } from "./components/ui/sonner";

// Pages
import Home from "./pages/Home";
import InHomeMassage from "./pages/InHomeMassage";
import StudioServices from "./pages/StudioServices";
import EnergyWork from "./pages/EnergyWork";
import Regressions from "./pages/Regressions";
import Janzu from "./pages/Janzu";
import FamilyConstellations from "./pages/FamilyConstellations";
import Events from "./pages/Events";
import Articles, { SingingBowlsArticle } from "./pages/Articles";
import EnergyWorkArticle from "./pages/EnergyWorkArticle";
import Hosts from "./pages/Hosts";
import Community from "./pages/Community";
import Store from "./pages/Store";
import About from "./pages/About";
import Contact from "./pages/Contact";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/in-home-massage" element={<InHomeMassage />} />
            <Route path="/studio-services" element={<StudioServices />} />
            <Route path="/energy-work" element={<EnergyWork />} />
            <Route path="/hipnosis" element={<Regressions />} />
            <Route path="/regressions" element={<Navigate to="/hipnosis" replace />} />
            <Route path="/janzu" element={<Janzu />} />
            <Route path="/constelaciones" element={<FamilyConstellations />} />
            <Route path="/family-constellations" element={<FamilyConstellations />} />
            <Route path="/events" element={<Events />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/singing-bowls" element={<SingingBowlsArticle />} />
            <Route path="/articles/energy-work-reiki-bioenergy" element={<EnergyWorkArticle />} />
            <Route path="/hosts" element={<Hosts />} />
            <Route path="/community" element={<Community />} />
            <Route path="/store" element={<Store />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
        <Toaster />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;

